/* Story Commerce LP の計測。
   playbook (12-story-commerce-playbook.md #artgraph analytics) が求める粒度に合わせる。
   「読了率」ではなく **物語の段を1つずつ進んだか** を見る。GA4 が無ければ何もしない。 */
(function () {
  'use strict';
  var root = document.querySelector('.ast');
  if (!root) return;
  var PAGE = root.getAttribute('data-ast') || 'artstory';
  var WORK = root.getAttribute('data-work') || '';

  function ga(name, extra) {
    if (typeof window.gtag !== 'function') return;
    var p = { story_page: PAGE, product_handle: WORK };
    if (extra) for (var k in extra) p[k] = extra[k];
    try { window.gtag('event', name, p); } catch (e) {}
  }
  var sent = Object.create(null);
  function once(key, name, extra) { if (sent[key]) return; sent[key] = 1; ga(name, extra); }

  once('view', 'story_hook_view', { page_height: document.body.scrollHeight });

  /* 物語の段。data-ast-step に段の名前が入っている。
     hero → discovery → resee → detail → bridge の到達率が、このページの本当の指標。 */
  var STEP_EVENT = {
    discovery: 'story_discovery_view',
    resee: 'artwork_resee_view',
    detail: 'story_detail_view',
    myth: 'story_myth_view',
    bridge: 'ownership_bridge_view',
    room: 'room_visual_view',
    quality: 'product_quality_view',
    purchase: 'purchase_info_view',
    letter: 'story_letter_view',
    artist_more: 'artist_works_view'
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var s = en.target.getAttribute('data-ast-step');
        if (STEP_EVENT[s]) once('st' + s, STEP_EVENT[s], { step: s });
        io.unobserve(en.target);
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('[data-ast-step]').forEach(function (el) { io.observe(el); });
  }

  /* CTA。どの段で押したかを必ず載せる（段ごとの効きが切れないと次の版が勘になる） */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-ast-cta]') : null;
    if (!a) return;
    var slot = a.getAttribute('data-ast-cta');
    ga('story_cta_click', { cta_slot: slot });
    /* 商品ページへ送る CTA は variant 選択の入口なので別名でも打つ */
    if (a.getAttribute('href') && a.getAttribute('href').indexOf('/products/') === 0) {
      ga('variant_open', { cta_slot: slot });
    }
  }, true);

  /* 深度は補助指標。主指標は上の段の到達率。 */
  var marks = [25, 50, 75, 100], ticking = false;
  function depth() {
    ticking = false;
    var h = document.body.scrollHeight - innerHeight;
    if (h <= 0) return;
    var pct = Math.min(100, Math.round(scrollY / h * 100));
    for (var i = 0; i < marks.length; i++) {
      if (pct >= marks[i]) once('d' + marks[i], 'story_scroll', { percent: marks[i] });
    }
  }
  addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(depth); }
  }, { passive: true });

  /* 追従バーは「所有への橋」を過ぎてから出す。
     物語の対価を払う前に売りに行かない（playbook: Cold social / discovery）。 */
  var bar = document.querySelector('.ast-bar');
  var flo = document.querySelector('.ast-float');
  var bridge = document.querySelector('[data-ast-step="bridge"]');
  if ((bar || flo) && bridge) {
    var on = false;
    addEventListener('scroll', function () {
      var want = bridge.getBoundingClientRect().top < innerHeight * 0.5;
      if (want === on) return;
      on = want;
      if (bar) bar.classList.toggle('is-on', on);
      if (flo) flo.classList.toggle('is-on', on);
      if (on) once('bar', 'story_bar_show');
    }, { passive: true });
  }

  /* ショーケースの購入ボタン。
     🔴 スニペット側の「カートに追加」は `.js-product-form-main [name="add"]` を代わりに押す作りで、
        商品フォームが無いこのページでは**押しても何も起きない**（2026-09-03 実測）。
        スニペットは商品ページと共有なので触らず、**このページだけ**差し替える。
     🔴 商品フォームがある面（＝商品ページ）では何もしない。将来この JS が別の面に載っても
        本来の動きを壊さないための番人。 */
  (function () {
    var atc = document.querySelector('[data-stg-atc]');
    if (!atc) return;
    if (document.querySelector('.js-product-form-main [name="add"]')) return;
    var src = document.querySelector('[data-ast-variants]');
    if (!src) return;
    var list, url = src.getAttribute('data-url') || '';
    try { list = JSON.parse(src.textContent); } catch (e) { return; }
    if (!list || !list.length || !url) return;

    atc.style.display = 'none';
    var go = document.createElement('a');
    go.className = 'btn btn--primary ar-stage__atc';
    go.setAttribute('data-ast-cta', 'showcase');
    go.href = url;
    go.textContent = 'この内容で購入へ進む';
    atc.parentNode.insertBefore(go, atc);

    function picked(name) {
      var e = document.querySelector('[data-optname="' + name + '"][aria-pressed="true"]');
      return e ? e.getAttribute('data-value') : null;
    }
    function find(sz, fr) {
      var i, v, loose = null;
      for (i = 0; i < list.length; i++) {
        v = list[i];
        if (v.s !== sz || v.f !== fr) continue;
        if (v.m === '余白あり') return v;
        if (!loose) loose = v;
      }
      return loose;
    }
    function sync() {
      var v = find(picked('サイズ'), picked('フレーム'));
      if (!v) { go.href = url; go.textContent = 'サイズを選ぶ'; go.removeAttribute('aria-disabled'); go.style.pointerEvents = ''; return; }
      go.href = url + '?variant=' + v.i;
      if (v.a) { go.textContent = 'この内容で購入へ進む'; go.removeAttribute('aria-disabled'); go.style.pointerEvents = ''; }
      else { go.textContent = '売り切れ'; go.setAttribute('aria-disabled', 'true'); go.style.pointerEvents = 'none'; }
    }
    sync();
    /* チップは capture では aria-pressed がまだ変わっていないので、少し待ってから読む */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-optname]')) setTimeout(sync, 80);
    }, true);
  })();

  /* 横に流れる帯。止められること自体が要件なので、ボタンの状態は aria-pressed で持つ。
     reduced-motion では CSS 側で animation:none なので、最初から止まって見える。 */
  var mq = document.querySelector('[data-ast-marquee]');
  var mqb = document.querySelector('[data-ast-marquee-btn]');
  if (mq && mqb) {
    mqb.addEventListener('click', function () {
      var paused = mq.classList.toggle('is-paused');
      mqb.setAttribute('aria-pressed', paused ? 'true' : 'false');
      mqb.setAttribute('aria-label', paused ? '流れを再開する' : '流れを止める');
      mqb.innerHTML = paused ? '&#9654;' : '&#10073;&#10073;';
    });
  }
})();
